export default __webpack_public_path__ + "static/media/TOPIK_Mock_Test_Exam_Paper.ef9cb9ad.pdf";